import { REQUEST_FROM } from "../../constants/syncLogs";

export default {
  SYNC_LOGS_LIST: "Liste des journaux",
  ADD_SYNC_LOG: "Ajouter un journal",
  SYNC_LOGS: "Journaux",
  SYNC_LOG: "Journal",
  SYNC_LOG_ADDED: "Journal ajouté",
  EDIT_SYNC_LOG: "Modifier un journal",
  SYNC_LOG_UPDATED: "Journal mis à jour",
  DELETE_THIS_SYNC_LOG: "Supprimer ce journal ?",
  SYNC_LOG_DELETED: "Journal supprimé",
  SYNC_LOG_TYPE: "Type de journal",
  VIEW_SYNC_LOG: "Journal",
  ENTITY_TYPE_ACCOUNT: "Compte",
  ENTITY_TYPE_CUSTOMER: "Client",
  ENTITY_TYPE_INVOICE: "Facture",
  ENTITY_TYPE_PAYMENT: "Paiement",
  ENTITY_TYPE_BATCH: "Batch",
  ENTITY_TYPE_SHIPMENT: "Expédition",
  ENTITY_TYPE_PICKUP: "Ramassage",
  ENTITY_TYPE_SERVICES: "Services",
  ENTITY_TYPE_SALES_ORDER: "Soumission",
  ENTITY_TYPE_ESTIMATE: "Soumission",
  ENTITY_TYPE_SIGNATURE_TEMPLATE: "Modèle de signature",
  ENTITY_TYPE_SIGNATURE: "Signature",
  ENTITY_TYPE_SERVICE: "Service",
  ENTITY_TYPE_ITEM: "Article",
  ENTITY_TYPE_TAX_CODE: "Code de taxe",
  ENTITY_TYPE_TAX_AGENCY: "Agence de taxe",
  ENTITY_TYPE_TAX_RATE: "Taux de taxe",
  ENTITY_TYPE_TAX_SERVICE: "Service de taxe",
  ENTITY_TYPE_JOURNAL_ENTRY: "Écriture de journal",
  ENTITY_TYPE_TRANSFER: "Transfert",
  ENTITY_TYPE_VENDOR: "Fournisseur",
  ENTITY_TYPE_MAIL_TEMPLATE: "Modèle de courriel",
  ENTITY_TYPE_MAIL_TYPE: "Type de courriel",
  REQUEST_FROM_SERVICE: "Service",
  REQUEST_FROM_APP: "Application",
  SYNC_STATUS_PENDING: "En attente",
  SYNC_STATUS_SUCCESS: "Réussie",
  SYNC_STATUS_FAILED: "Echouée",
  ACTION_CREATE: "Création",
  ACTION_UPDATE: "Mise à jour",
  ACTION_DELETE: "Suppression",
  ACTION_BATCH: "Batch",
  ACTION_GET: "Sélection",
  ACTION_QUERY: "Sélection",
  ACTION_CANCEL: "Annulation",
  ACTION_TRACK: "Suivie",
  ACTION_PRINTLABEL: "Impression d'étiquette",
  ACTION_RATE_ESTIMATE: "Estimation de tarif",
  ACTION_SEND: "Envoi",
  ACTION_VALIDATED: "Validée",
  ACTION_VOID: "Annulation",
  ACTION_DENIED: "Refusée",
  ACTION_GET_EDITOR: "Éditeur",
  ACTION_DOWNLOAD: "Téléchargement",
  ACTION_DOWNLOAD_BASE64: "Téléchargement (Base64)",
  ACTION_CAPTURE: "Capture",
  ACTION_REFUND: "Remboursement",
  ACTION_INITIATE: "Initiation",
  ACTION_PREVIEW: "Aperçu",
  ACTION_SUBSCRIBED: "Souscription",
  ACTION_EMAILED: "Envoi par email",
  ENTITY_TYPE: "Entité à synchroniser",
  ACTION: "Action",
  REQUEST_FROM: "Initiée par ",
  REQUEST_DATA: "Données envoyés",
  RESPONSE_DATA: "Réponse de la demande",
  STATUS: "Statut",
  ATTEMPS: "Nombre d'éssaie",
  LAST_ATTEMPT_AT: "Date du dernier éssaie",
  SERVICE: "Service",
  RETRY: "Réessayer",
  RELAUNCH: "Relancer",
  RETRY_THIS_SYNC: "Relancer cette synchronisation ?",
  SYNC_RELAUNCHED: "Synchronisation relancée avec succès",
  AUTO_ATTEMPTS: "Relance auto",
  DISABLE_AUTO_ATTEMPTS: "Désactiver la relance auto",
  ENABLE_AUTO_ATTEMPTS: "Activer la relance auto",
  UPDATE_THIS_SYNC_AUTO_ATTEMPTS:
    "Modifier la relance auto pour cette synchronisation ?",
  AUTO_ATTEMPTS_UPDATED: "Relance auto modifié avec succès",
};
